import { Button } from '@/components/atoms/NewPcButton';
import { DialogClose } from '@/components/atoms/Dialog';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useAppSelector } from '@/redux/store';
import {
  SELLERBOX_PLUS_MONTHLY_AMOUNT,
  SELLERBOX_PLUS_SUBSCRIPTION_NO,
} from '@/constants/subscription';

interface NewPaymentDialogProps {
  isPrePayment?: boolean;
  subscriptionNo: number;
  paymentAmount: number;
}

const ChangeBillKakao = ({
  isPrePayment,
  subscriptionNo,
  paymentAmount,
}: NewPaymentDialogProps) => {
  const { CplatToken } = useAppSelector((state) => state.user);

  // 2. 카카오페이 결제 준비
  const { mutate: readyKakaoPay, isPending: isPayLoading } = usePost(
    CPLAT_API_ROUTES.paymentReadyForKakaoPay,
  );

  const handleKakaoPay = () => {
    if (!CplatToken) {
      alert('로그인이 필요합니다.');
      return;
    }
    if (!subscriptionNo) {
      alert('멤버십 정보가 없습니다.');
      return;
    }
    readyKakaoPay(
      {
        cplatToken: CplatToken,
        subscriptionNo: SELLERBOX_PLUS_SUBSCRIPTION_NO,
        isPrePayment: isPrePayment,
      },
      {
        onSuccess: (res) => {
          const { KakaoPayRequestInfo, KakaoPayResponseInfo } = res.data.data[0];

          localStorage.setItem('kakaoPayRequestInfo', JSON.stringify(KakaoPayRequestInfo));
          localStorage.setItem('kakaoPayResponseInfo', JSON.stringify(KakaoPayResponseInfo));
          localStorage.setItem('subscriptionNo', String(SELLERBOX_PLUS_SUBSCRIPTION_NO));
          window.location.href = KakaoPayResponseInfo.NextRedirectPcUrl;
        },
        onError: () => {
          alert('카카오페이 결제 준비에 실패했습니다.');
        },
      },
    );
  };

  return (
    <div className="flex w-full items-center justify-end gap-5">
      <div className="flex flex-col items-end">
        <div className="text-gr-900 Body1S16">
          결제 금액 {paymentAmount !== undefined ? paymentAmount.toLocaleString() : '-'}원
        </div>
        {isPrePayment && (
          <div className="mt-[2px] text-gr-500 Caption1M12">
            14일 무료 체험 이후 {SELLERBOX_PLUS_MONTHLY_AMOUNT.toLocaleString()}원이 자동
            결제됩니다
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <DialogClose asChild>
          <Button size="small" variant="line" className="h-[38px] shadow-none">
            취소
          </Button>
        </DialogClose>
        <Button
          size="small"
          isLoading={isPayLoading}
          onClick={handleKakaoPay}
          disabled={isPayLoading || !subscriptionNo}
          className="h-[38px]"
        >
          다음
        </Button>
      </div>
    </div>
  );
};

export default ChangeBillKakao;
